import { NgModule } from '@angular/core';
import { OpportunityDetailsService } from './opportunity-details.service';
import { OpportunityDetailsComponent } from './opportunity-details.component';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { OpportunityAttachmentsModule } from './opportunity-attachments/opportunity-attachments.module';
import { OpportunityTagsModule } from './opportunity-tags/opportunity-tags.module';
import { OpportunityInfoModule } from './opportunity-info/opportunity-info.module';
import { OpportunityQualificationModule } from './opportunity-qualification/opportunity-qualification.module';
import { BusinessInfoModule } from './opportunity-account-info/business-info.module';
import { OpportunityNotesModule } from '../../../notes/opportunity-notes.module';
import { SalesOrderConfirmationModule } from '../../../sales-orders/sales-order-confirmation/sales-order-confirmation.module';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { OpportunityActivitiesModule } from '../activities/opportunity-activities.module';

@NgModule({
  imports: [
    CommonModule,
    MatExpansionModule,
    MatIconModule,
    TranslateModule,
    OpportunityAttachmentsModule,
    OpportunityTagsModule,
    OpportunityInfoModule,
    OpportunityQualificationModule,
    OpportunityNotesModule,
    SalesOrderConfirmationModule,
    BusinessInfoModule,
    MatTabsModule,
    MatToolbarModule,
    OpportunityActivitiesModule,
  ],
  declarations: [OpportunityDetailsComponent],
  exports: [OpportunityDetailsComponent],
  providers: [OpportunityDetailsService],
})
export class OpportunityDetailsModule {}
